module.exports = __webpack_public_path__ + "static/axiforma-regular-webfont-ea580a321609b6cf95c9705d5ff5ae3d.woff2";